import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Fieldset = _styled("fieldset", {
  target: "en6f8fp0",
  label: "Fieldset"
})(process.env.NODE_ENV === "production" ? {
  name: "56zmzk",
  styles: "border:0;margin:0;padding:0;"
} : {
  name: "56zmzk",
  styles: "border:0;margin:0;padding:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1FbGVtZW50cy9BZGRyZXNzL3N0eWxlZENvbXBvbmVudHMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR2dDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1FbGVtZW50cy9BZGRyZXNzL3N0eWxlZENvbXBvbmVudHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBFeHRlcm5hbCBsaWJyYXJpZXNcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgRmllbGRzZXQgPSBzdHlsZWQuZmllbGRzZXRgXG4gIGJvcmRlcjogMDtcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwO1xuYDtcblxuY29uc3QgTGVnZW5kID0gc3R5bGVkLmxlZ2VuZGBcbiAgcGFkZGluZzogMDtcbmA7XG5cbmV4cG9ydCB7IEZpZWxkc2V0LCBMZWdlbmQgfTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Legend = _styled("legend", {
  target: "en6f8fp1",
  label: "Legend"
})(process.env.NODE_ENV === "production" ? {
  name: "y8aj3r",
  styles: "padding:0;"
} : {
  name: "y8aj3r",
  styles: "padding:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1FbGVtZW50cy9BZGRyZXNzL3N0eWxlZENvbXBvbmVudHMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUzRCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1FbGVtZW50cy9BZGRyZXNzL3N0eWxlZENvbXBvbmVudHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBFeHRlcm5hbCBsaWJyYXJpZXNcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgRmllbGRzZXQgPSBzdHlsZWQuZmllbGRzZXRgXG4gIGJvcmRlcjogMDtcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwO1xuYDtcblxuY29uc3QgTGVnZW5kID0gc3R5bGVkLmxlZ2VuZGBcbiAgcGFkZGluZzogMDtcbmA7XG5cbmV4cG9ydCB7IEZpZWxkc2V0LCBMZWdlbmQgfTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { Fieldset, Legend };